// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"297":"aea61ef7","950":"7f834df8"}[chunkId] + ".js";
};